import generalBannerSoldier from '../assets/general/general-banner-soldier.webp';
import { ReactComponent as LocationIcon } from 'src/assets/services/navbar/footter_locations.svg';
import { ReactComponent as MapIcon } from 'src/assets/services/navbar/footter_map.svg';
import { ReactComponent as WorkIcon } from 'src/assets/services/navbar/footter_work.svg';
import { ReactComponent as KbIcon } from 'src/assets/services/navbar/footter_kb.svg';
import { ReactComponent as CourcesIcon } from 'src/assets/services/navbar/footter_cources.svg';
import { ReactComponent as EventsIcon } from 'src/assets/services/navbar/footter_event.svg';
import { ReactComponent as PhoneIcon } from 'src/assets/services/navbar/footter_phone.svg';

export const ogbaseImagePath = ``;

export const GENERAL = {
    path: '/',
    relativePath: '',
    title: 'Головна',
    meta: {
      title: "На зв'язку | Інформаційна платформа для захисників та їхніх родин",
      description:
        "Отримайте інформацію та безкоштовні послуги для захисників та їхніх родин в єдиному місці на офіційному веб-сайті На зв'язку.",
      openGraph: {
        img: generalBannerSoldier,
        type: 'website'
      }
    }
  },
  ABOUT = {
    path: '/about',
    relativePath: 'about',
    meta: {
      title: "На зв'язку | Інформаційна платформа для захисників та їхніх родин",
      description:
        "Отримайте інформацію та безкоштовні послуги для захисників та їхніх родин в єдиному місці на офіційному веб-сайті На зв'язку.",
      openGraph: {
        img: generalBannerSoldier,
        type: 'website'
      }
    }
  },
  WORK = {
    path: '/work',
    relativePath: 'work'
  },
  WORK_SEARCH = {
    path: '/work/work-search',
    relativePath: 'work-search',
    title: 'Пошук вакансій',
    meta: {
      title: "На зв'язку | Пошук вакансій",
      description:
        "Отримайте інформацію та підтримку щодо пошуку роботи для захисників та їхніх родин на офіційному веб-сайті На зв'язку.",
      openGraph: {
        img: generalBannerSoldier,
        type: 'website'
      },
      menuIcon: <WorkIcon />
    }
  },
  VACANCY_PAGE = {
    path: '/work/work-search/vacancy',
    relativePath: 'work-search/vacancy',
    title: 'vacancyDetailPageTitle'
  },
  CAREER_INFO = {
    path: '/work/career-info',
    relativePath: 'career-info',
    title: 'Кар’єрні матеріали',
    meta: {
      title: "На зв'язку | Інформація про кар'єрні можливості для захисників та їхніх родин",
      description:
        "Дізнайтеся про кар'єрні можливості та професійні переваги для захисників та їхніх родин на офіційному веб-сайті На зв'язку.",
      openGraph: {
        img: generalBannerSoldier,
        type: 'website'
      }
    }
  },
  EDUCATION = {
    path: '/education',
    relativePath: 'education'
  },
  EDUCATION_COURSES = {
    path: '/education/courses',
    relativePath: 'courses',
    title: 'Каталог курсів',
    meta: {
      title: "На зв'язку | Освітні курси для захисників та їхніх родин",
      description:
        "Ознайомтеся з доступними освітніми курсами та навчальними можливостями для захисників та їхніх родин на офіційному веб-сайті На зв'язку.",
      openGraph: {
        img: generalBannerSoldier,
        type: 'website'
      },
      menuIcon: <CourcesIcon />
    }
  },
  EDUCATION_INFO = {
    path: '/education/info',
    relativePath: 'info',
    title: 'Освітні матеріали',
    meta: {
      title: "На зв'язку | Освітні матеріали для захисників та їхніх родин",
      description:
        "Ознайомтеся з освітніми матеріалами для захисників та їхніх родин на офіційному веб-сайті На зв'язку.",
      openGraph: {
        img: generalBannerSoldier,
        type: 'website'
      }
    }
  },
  PSYCHOLOGICAL_HELP = {
    path: '/psychological-help',
    relativePath: 'psychological-help',
    title: 'Психологічна підтримка',
    meta: {
      title: "На зв'язку | Інформація про психологічну підтримку для захисників та їхніх родин",
      description:
        "Отримайте інформацію та консультування щодо психологічної підтримки для захисників та їхніх родин на офіційному веб-сайті На зв'язку.",
      openGraph: {
        img: generalBannerSoldier,
        type: 'website'
      }
    }
  },
  LEGAL_HELP = {
    path: '/legal-help',
    relativePath: 'legal-help',
    title: 'Юридична допомога',
    meta: {
      title: "На зв'язку | Правова допомога для захисників та їхніх родин",
      description:
        "Дізнайтеся про доступні правові послуги та консультації для захисників та їхніх родин на офіційному веб-сайті На зв'язку.",
      openGraph: {
        img: generalBannerSoldier,
        type: 'website'
      }
    }
  },
  USEFUL_INFO = {
    path: '/useful-info',
    relativePath: 'useful-info',
    title: 'Корисна інформація',
    meta: {
      title: "На зв'язку | Корисна інформація для захисників та їхніх родин",
      description:
        "Отримайте корисну інформацію та поради для захисників та їхніх родин на офіційному веб-сайті На зв'язку.",
      openGraph: {
        img: generalBannerSoldier,
        type: 'website'
      }
    }
  },
  COOKIES_POLICIES = {
    path: '/cookies-policy',
    relativePath: 'cookies-policy',
    title: 'Політика використання cookies',
    meta: {
      title: "На зв'язку | Політика використання cookies",
      description:
        'Ця Політика використання файлів cookie пояснює, як наш вебсайт використовує файли cookie та інші подібні технології для покращення вашого досвіду користування.'
    }
  },
  PERSONAL_DATA_POLICIES = {
    path: '/personal-data-policy',
    relativePath: 'personal-data-policy',
    title: 'Згода на обробку персональних даних',
    meta: {
      title: "На зв'язку | Згода на обробку персональних даних",
      description: ''
    }
  },
  EVENTS = {
    path: '/events',
    relativePath: 'events',
    title: 'Події',
    meta: {
      title: "На зв'язку | Події та заходи для захисників та їхніх родин",
      description:
        "Дізнайтеся про події та заходи, організовані для захисників та їхніх родин на офіційному веб-сайті На зв'язку.",
      openGraph: {
        img: generalBannerSoldier,
        type: 'website'
      },
      menuIcon: <EventsIcon />
    }
  },
  PARTNERSHIP = {
    path: '/partnership',
    relativePath: 'partnership',
    title: 'Партнери та надавачі послуг',
    meta: {
      title: "На зв'язку | Партнерство зі спільнотою",
      description: "Дізнайтеся про можливості партнерства та співпраці з На зв'язку на офіційному веб-сайті.",
      openGraph: {
        img: generalBannerSoldier,
        type: 'website'
      }
    }
  },
  BUSINESS_MAP = {
    path: '/map',
    relativePath: 'map',
    title: 'Цифрова мапа знижок',
    meta: {
      title: "На зв'язку | Цифрова мапа бізнесів лояльних до захисників та їхніх родин",
      description:
        "Бізнеси які надають послуги або сервіси зі знижкою або безкоштовно для військовослужбовців та їхніх родин на офіційному веб-сайті На зв'язку.",
      openGraph: {
        img: generalBannerSoldier,
        type: 'website'
      },
      menuIcon: <MapIcon />
    }
  },
  VETERAN_LOCATIONS = {
    path: '/locations',
    relativePath: 'locations',
    title: 'Локації',
    meta: {
      title: "На зв'язку | Локації для захисників та їхніх родин",
      description:
        "Локації для захисників та їхніх родин на На зв'язку. Отримайте соціальну підтримку та консультації.",
      openGraph: {
        img: generalBannerSoldier,
        type: 'website'
      },
      menuIcon: <LocationIcon />
    }
  },
  MEDICAL_SERVICES = {
    path: '/medical-services',
    relativePath: 'medical-services',
    title: 'Медичні послуги',
    meta: {
      title: "На зв'язку | Медичні послуги для захисників та їхніх родин",
      description:
        "Центри протезування та реабілітації, а також слухопротезування та зубопротезування з На зв'язку на офіційному веб-сайті.",
      openGraph: {
        img: generalBannerSoldier,
        type: 'website'
      }
    }
  },
  GLOBAL_SEARCH = {
    path: '/global-search',
    relativePath: 'global-search',
    title: 'Глобальний пошук',
    meta: {
      title: "На зв'язку | Глобальний пошук",
      description: 'Знайдіть потрібне за кілька кліків'
    }
  },
  NEWS = {
    path: '/news',
    relativePath: 'news',
    title: 'Новини',
    meta: {
      title: "На зв'язку | Новини",
      description: 'Загальні новини та оновлення сервісу',
      openGraph: {
        img: generalBannerSoldier,
        type: 'website'
      }
    }
  },
  CONTACTS = {
    path: '/contacts',
    relativePath: 'contacts',
    title: 'Каталог контактів',
    meta: {
      title: "На зв'язку | Каталог контактів",
      description: 'Контакти ТЦК та СП, служб супроводу, КШППВ.',
      openGraph: {
        img: generalBannerSoldier,
        type: 'website'
      },
      menuIcon: <PhoneIcon />
    }
  },
  KNOWLEDGE_BASE = {
    path: '/knowledge-base',
    relativePath: 'knowledge-base',
    title: 'База знань',
    meta: {
      title: "На зв'язку | База знань",
      description:
        'Корисні ресурси для цивільно-військового співробітництва, включаючи статті, посібники та дослідження.',
      openGraph: {
        img: generalBannerSoldier,
        type: 'website'
      },
      menuIcon: <KbIcon />
    }
  };

const routes = [
    GENERAL,
    WORK_SEARCH,
    VACANCY_PAGE,
    CAREER_INFO,
    EDUCATION_COURSES,
    EDUCATION_INFO,
    PSYCHOLOGICAL_HELP,
    MEDICAL_SERVICES,
    LEGAL_HELP,
    USEFUL_INFO,
    EVENTS,
    PARTNERSHIP,
    BUSINESS_MAP,
    VETERAN_LOCATIONS,
    NEWS,
    COOKIES_POLICIES,
    GLOBAL_SEARCH,
    KNOWLEDGE_BASE,
    CONTACTS
  ],
  SERVICES_ROUTES = [MEDICAL_SERVICES, USEFUL_INFO, PSYCHOLOGICAL_HELP, LEGAL_HELP, EDUCATION_INFO, CAREER_INFO, NEWS],
  SERVICES_WITH_ICONS = [
    VETERAN_LOCATIONS,
    BUSINESS_MAP,
    WORK_SEARCH,
    EDUCATION_COURSES,
    KNOWLEDGE_BASE,
    EVENTS,
    CONTACTS
  ];

export { routes, SERVICES_ROUTES, SERVICES_WITH_ICONS };
